import { client } from './client';

export const getMeterType = (udprn) =>
  client(`premises/${udprn}/services`, {
    method: 'GET'
  });
